import Head from 'next/head';

import Checkout from '../../components/Checkout';
import { pageTitle } from '../../components/shared/basic/customHead';

const CheckoutPage = () => {
  return (
    <>
      <Head>
        <title>{pageTitle('checkout')}</title>
      </Head>

      <Checkout />
    </>
  );
};

export default CheckoutPage;
